module.exports = __webpack_public_path__ + "static/media/popcorn.ecaf44a3.svg";